import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestViewMarketProductListings, requestBookmarkProductListing } from '../../../api/product/product.actions';
import { setProductListings } from '../../../slices/product/product.slice';

import ProductListings from '../../../components/screens/market/product-listings/MarketProductListings';

const MarketProductListingsContainer = () => {
  const { productListings } = useSelector(({ product }) => product);
  const currencyCode = useSelector(({ currency }) => currency.currencyCode);

  const [bookmarkedListings, setBookmarkedListings] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    const filters = {};

    dispatch(requestViewMarketProductListings({ filters }));

    return () => dispatch(setProductListings([]));
  }, [dispatch, currencyCode]);

  useEffect(() => {
    if (productListings) {
      const bookmarkedListingReferences = [];
      productListings.forEach((listing) => {
        if (listing.bookmarked) {
          bookmarkedListingReferences.push(listing.productExternalReference);
        }
      });
      setBookmarkedListings(bookmarkedListingReferences);
    }
  }, [productListings]);

  const applyFilters = (filtersToApply) => {
    const filters = {
      ...filtersToApply,
    };

    dispatch(requestViewMarketProductListings({ filters }));
  };

  const addToBookmarks = (newProductReference) => {
    setBookmarkedListings([...bookmarkedListings, newProductReference]);
  };

  const removeFromBookmarks = (productReferenceToRemove) => {
    setBookmarkedListings(bookmarkedListings.filter((reference) => reference !== productReferenceToRemove));
  };

  const isProductBookmarked = (reference) => {
    return bookmarkedListings.includes(reference);
  };

  const addOrRemoveProductFromBookmarks = (reference) => {
    if (isProductBookmarked(reference)) {
      removeFromBookmarks(reference);
    } else {
      addToBookmarks(reference);
    }
  };

  const updateBookmark = (productExternalReference) => {
    dispatch(
      requestBookmarkProductListing({
        productExternalReference: productExternalReference,
        type: 'seller',
        onSuccess: () => addOrRemoveProductFromBookmarks(productExternalReference),
      })
    );
  };

  return (
    <ProductListings
      listings={productListings}
      applyFilters={applyFilters}
      isProductBookmarked={isProductBookmarked}
      updateBookmark={updateBookmark}
      currencyCode={currencyCode}
    />
  );
};

export default MarketProductListingsContainer;
